import { render } from "./meta2.vue?vue&type=template&id=4a73b0ab&scoped=true"
import script from "./meta2.vue?vue&type=script&lang=js"
export * from "./meta2.vue?vue&type=script&lang=js"

import "./meta2.vue?vue&type=style&index=0&id=4a73b0ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a73b0ab"]])

export default __exports__